// extracted by mini-css-extract-plugin
export default {"flex":"style_flex__f8jhB","img":"style_img__5cWYY","text":"style_text__+4Kg1","grid":"style_grid__diJas"};